import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { useQueryParams } from '@insurancemenu/imenu-components-lib';
import { useParams } from 'react-router-dom';
import { useRootStore } from 'store/rootStore';
import FormsSpinner from 'components/common/loaders/FormSpinner';
import MainInfoPanel from 'components/proposal-v2/MainInfoPanel';
import ProposalPlans from 'components/proposal-v2/ProposalPlans';
import UWGuidelines from 'components/common/general/UWGuidelines';

const ProposalPageContent: React.FC = observer(() => {
  const query = useQueryParams();
  const { periodId } = useParams<{ periodId: string }>();

  const { proposalItemsStore, domainStoreV2 } = useRootStore();

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    void proposalItemsStore.collectProposalData(query.get('groupId')!, query.get('cartId')!, periodId);
  }, []);

  return (
    <>
      {!proposalItemsStore.loadingGetter && (
        <>
          <MainInfoPanel />
          {domainStoreV2.showQuotingUWGuidelinesFeature ? (
            <UWGuidelines uwGuidelines={proposalItemsStore.uwGuidelines} />
          ) : null}
          <ProposalPlans />
        </>
      )}
      <FormsSpinner display={proposalItemsStore.loading} />
    </>
  );
});

export default ProposalPageContent;
